<template>
  <div class="utils">
    <div class="list">
      <el-button type="primary" plain @click="toUrl('/utils/smsInquiry')">短信查询</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'utils',
  data () {
    return {}
  },
  methods: {
    toUrl(url) {
      this.$router.push(url)
    }
  }
}
</script>

<style lang="less" scoped>
  .utils{
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .list{
    box-sizing: border-box;
    padding: 20px 24px;
    width: 100%;
  }
</style>
